<template>
  <div class="head">
    <div style="display: flex;align-items: center;height: 100px;width: 100%;">
      <!--    二维码  -->
      <qrcode-vue :value="single.currentCode.qrCode" size:100></qrcode-vue>
      <div style="width: 80%;display: flex;justify-content: center;align-items: center;flex-direction: column">
        <a-space align="center" style="height: 70px">
          <a-popover placement="bottom" trigger="click">
            <template #content>
              <div style="display: flex;flex-direction: column">
                <a-button type="primary" shape="circle" :size="size" @click="single.changeDevLabel(0)">
                  <template #icon>
                    <stop-outlined/>
                  </template>
                </a-button>
                <template v-for="i in 6" :key="i">
                  <span style="margin: 5px 0">
                    <a-image :preview="false" :width="25" :src="single.devTagUrl(i)"
                             @click="single.changeDevLabel(i)"></a-image>
                  </span>
                </template>
              </div>
            </template>
            <a-tooltip title="给设备添加标记" color="#2db7f5" v-if="!single.currentCode.label">
              <a-button type="primary" shape="circle" :size="size">
                <template #icon>
                  <stop-outlined/>
                </template>
              </a-button>
            </a-tooltip>
            <a-tooltip title="给设备添加标记" color="#2db7f5" v-else>
              <a-image style="cursor: pointer" :preview="false" :width="25"
                       :src="single.devTagUrl(single.currentCode.label)"></a-image>
            </a-tooltip>
          </a-popover>
          <span style="font-weight: bold;font-size: 26px;color: #9d0a0a">{{ single.currentCode.qrCode || '--' }}</span>
          <span style="font-weight: bold;font-size: 26px;color: #909">{{ single.currentCode.netType || '--' }}</span>
          <a-tooltip title="在地图上找到它?" color="#2db7f5">
            <a-button type="primary" shape="circle" :size="size" @click="map=true">
              <template #icon>
                <EnvironmentOutlined/>
              </template>
            </a-button>
          </a-tooltip>
        </a-space>
        <a-space :size="60">
          <a-typography-text v-if="single.currentCode.last.online === 1" style="cursor: pointer;color: rgb(85, 26, 139);font-weight: bold"
                             @click="single.changeCurrentCode(single.currentCode.last.code,[],'list',true)" underline>
            {{ single.currentCode.last.code }}←
          </a-typography-text>
          <a-typography-text v-else style="cursor: pointer;color: rgb(85, 26, 139);font-weight: bold"
                             @click="single.changeCurrentCode(single.currentCode.last.code,[],'list',true)" underline>
            <s>{{ single.currentCode.last.code }}←</s>
          </a-typography-text>
          <a-typography-text style="color: rgb(0, 0, 153);font-weight: bold">
            <a-space v-if="single.currentCode.getDevTagList.length" wrap align="center">
              <a-tag style="cursor: pointer" :color="randomHexColor()"
                     v-for="(item,index) in single.currentCode.getDevTagList" :key="index">
                {{ item.tagName }}
              </a-tag>
            </a-space>
            <span style="margin-right: 10px" v-else>[NO TAG]</span>
            <a-popover placement="bottom" trigger="click">
              <template #content>
                <p>已绑定标签</p>
                <a-space direction="vertical">
                  <a-space v-if="single.currentCode.getDevTagList.length">
                    <a-tag style="cursor: pointer" :color="randomHexColor()"
                           @close="(event)=>single.handleClose(item,event)"
                           closable
                           v-for="(item,index) in single.currentCode.getDevTagList" :key="index">
                      {{ item.tagName }}
                    </a-tag>
                  </a-space>
                  <span v-else style="color: rgb(0, 0, 153);font-weight: bold">[NO TAG]</span>
                  <!--          可以绑定的标签        -->
                  <p>标签列表</p>
                  <a-card style="width: 400px;margin-bottom: 15px">
                    <a-space wrap align="center">
                      <a-tag style="cursor: pointer" :color="randomHexColor()"
                             @click="addInBulk(item)"
                             v-for="(item,index) in tag.tagListInfo" :key="index">
                        {{ item.tagName }}
                        <plus-outlined/>
                      </a-tag>
                      <a-input
                          v-if="inputVisible"
                          ref="inputRef"
                          v-model:value="newTagName"
                          type="text"
                          size="small"
                          :style="{ width: '78px' }"
                          @blur="handleInputConfirm"
                      />
                      <a-tag v-else style="background: #fff; border-style: dashed" @click="showInput">
                        <plus-outlined/>
                        New Tag
                      </a-tag>
                    </a-space>
                  </a-card>
                </a-space>
              </template>
              <a-tooltip title="给设备添加标签" color="#2db7f5">
                <edit-outlined style="cursor: pointer"/>
              </a-tooltip>
            </a-popover>

          </a-typography-text>
          <a-typography-text v-if="single.currentCode.next.online === 1"
                             style="cursor: pointer;color: rgb(0, 0, 255);font-weight: bold"
                             @click="single.changeCurrentCode(single.currentCode.next.code,[],'list',true)" underline>
            →{{ single.currentCode.next.code }}
          </a-typography-text>
          <a-typography-text v-else style="cursor: pointer;color: rgb(0, 0, 255);font-weight: bold"
                             @click="single.changeCurrentCode(single.currentCode.next.code,[],'list',true)" underline>
            <s>→{{ single.currentCode.next.code }}</s>
          </a-typography-text>
        </a-space>
      </div>
    </div>
    <v-map v-if="map" :search="single.currentCode.qrCode" :showType="single.currentCode.type" :visible="map"
           @showMap="showMap"/>
  </div>
</template>
<script setup>
import singleDev from "@/stores/singleDev";
import tagStore from "@/stores/tagStore";
import QrcodeVue from 'qrcode.vue';
import {
  EnvironmentOutlined,
  StopOutlined,
  EditOutlined,
  PlusOutlined,
} from '@ant-design/icons-vue';
import {nextTick, onMounted, ref} from "vue";
import tagList from "@/layouts/admin-sidebar/tag/list/tagList.js";
import load from "@/common/load";
import {axiosPost} from "@/layouts/admin-sidebar/requstDev";
import api from "@/service/api";
import userStore from "@/stores/user";
import VMap from "@/components/v-map.vue";

let tag = tagStore();
let map = ref(false)
let showMap = (val) => {
  map.value = val
}
let {
  randomHexColor
} = tagList();
let single = singleDev();
let size = ref('small');
// 新标签名称
let newTagName = ref("");
let inputVisible = ref(false);
if (single.currentCode.netType === '') {
  single.obtainTheDeviceNetworkingType('getDevType', single.assignInformationFunctions);
}
let inputRef = ref();
const showInput = () => {
  inputVisible.value = true;
  nextTick(() => {
    inputRef.value.focus();
  });
};
let user = userStore();
let handleInputConfirm = () => {
  if (!newTagName.value) {
    inputVisible.value = false;
    return
  }
  load.confirm(`是否将标签"${newTagName.value}"添加给设备${single.currentCode.qrCode}?`, async () => {
    load.loading("添加中...")
    try {
      let result = await axiosPost(api.insertDevNewTage, {
        userId: user.userId,
        data: {
          uniqueCodes: [single.currentCode.qrCode],
          newTagName: newTagName.value
        },
      })
      inputVisible.value = false;
      newTagName.value = "";
      if (result.result === '1') {
        load.success("添加成功...")
        tag.initTagList();
        single.getDevTag();
      } else {
        load.error(result.msg);
      }
    } catch (e) {
      load.error(`给新标签${newTagName.value}添加设备失败...`)
    }
  })
}
// 批量添加标签
let addInBulk = (item) => {
  load.confirm(`是否确定将${single.currentCode.qrCode}设备添加到“${item.tagName}”标签里面`, async () => {
    load.loading("添加中...")
    try {
      let result = await axiosPost(api.insertDevTage, {
        userId: user.userId,
        data: {
          uniqueCodes: [single.currentCode.qrCode],
          tagId: item.tagId
        },
      })
      if (result.result === '1') {
        load.success("添加成功...");
        single.getDevTag();
      } else {
        load.error(result.msg);
      }
    } catch (e) {
      load.error(`给标签${item.tagName}添加设备失败...`)
    }
  })
}
onMounted(() => {
  single.getDevTag();
})
</script>
<style>
.ant-popover {
  z-index: 999 !important;
}
</style>
<style scoped lang="scss">
.head {
  padding: 30px 40px;
  box-sizing: border-box;
}
</style>
